
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PeriodicClosingDialog extends Serenity.EntityDialog<PeriodicClosingRow, any> {
        protected getFormKey() { return PeriodicClosingForm.formKey; }
        protected getIdProperty() { return PeriodicClosingRow.idProperty; }
        protected getLocalTextPrefix() { return PeriodicClosingRow.localTextPrefix; }
        protected getNameProperty() { return PeriodicClosingRow.nameProperty; }
        protected getService() { return PeriodicClosingService.baseUrl; }
        protected getDeletePermission() { return PeriodicClosingRow.deletePermission; }
        protected getInsertPermission() { return PeriodicClosingRow.insertPermission; }
        protected getUpdatePermission() { return PeriodicClosingRow.updatePermission; }

        protected form = new PeriodicClosingForm(this.idPrefix);

        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();

            //buttons.push({
            //    title: 'Print Register',
            //    cssClass: 'export-pdf-button',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Finance.PeriodicClosing',
            //            params: {
            //                FinancialYearId: parseInt(this.form.FinancialYear.value)
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
        protected updateInterface(): void {

            super.updateInterface();
            var x = this.isNew();
            if (!this.isNew()) {

                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);

                // remove required asterisk (*)
                this.element.find('sup').hide();
                this.deleteButton.hide();
                this.saveAndCloseButton.hide();
                this.applyChangesButton.hide();
            }
        }
    }
}